module.exports = __webpack_public_path__ + "static/img/platphom5.cacc6d41.png";